<custom-dropdown-list-container [(isDropdownOpen)]="isDropdownOpen">
    <div class="custom-box multi-select-toggle" [class.multi-select-toggle-open]="isDropdownOpen" dropdown-toggle>
        <div class="custom-box-inner">
            <div class="custom-box-text">{{getLabel()}}</div>
            <div class="custom-box-icon"><img src="assets/icons/solid-arrow.svg"></div>
        </div>
    </div>
    <div class="custom-multi-select-items" dropdown-list>
        <div class="custom-box custom-selectable-item custom-multi-select-item" *ngFor="let item of items" (click)="selectItem(item)">
            <div class="custom-box-inner custom-multi-select-item-inner">
                <div>
                    <input class="custom-multi-select-check" type="checkbox" [checked]="isItemSelected(item)">
                </div>
                <div>{{item.name}}</div>
            </div>
        </div>
    </div>
</custom-dropdown-list-container>
